import { enUS, es, ptBR } from 'date-fns/locale';

const LOCALE_MAP = {
  en: enUS,
  es,
  pt_BR: ptBR,
};

export function getDateFnsLocale(locale) {
  return LOCALE_MAP[locale] || enUS;
}
